import { DateTime } from 'luxon';
import type { ArrivalWindowPresetView } from '@/types/schedulingV2';
import { arrivalWindowBusinessUnitIds } from '@/hooks/scheduling-v2/useArrivalWindowPresets';
export function applicableArrivalPresets(
  presets: readonly ArrivalWindowPresetView[],
  context: {
    jobTypeId?: string;
    businessUnitId?: string;
    date?: string;
  },
) {
  const day = context.date ? DateTime.fromISO(context.date) : null;
  return presets.filter((preset) => {
    const units = arrivalWindowBusinessUnitIds(preset);
    return (
      preset.isActive &&
      (!preset.jobTypeId || preset.jobTypeId === context.jobTypeId) &&
      (!units.length ||
        Boolean(context.businessUnitId && units.includes(context.businessUnitId))) &&
      (!preset.weekdays.length ||
        Boolean(day?.isValid && preset.weekdays.includes(day.weekday % 7)))
    );
  });
}
